import { useGetAiMappingTaskStatusLazyQuery } from "generated/graphql";

export default function useGetAiMappingTaskStatus() {
  const [fetch, { data, loading, error }] = useGetAiMappingTaskStatusLazyQuery();
  return [fetch, { data, loading, error }] as const;
}
